import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const DatabaseKeyPage = () => {
  const [dbKey, setDbKey] = useState("");
  const navigate = useNavigate();

  const handleSubmit = () => {
    if (!dbKey) {
      alert("Please select a database key!");
      return;
    }
    sessionStorage.setItem("databaseKey", dbKey);
    navigate("/login");
  };

  const options = ["erpsppipe", "spflerp2025"]; 

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img
          src="https://cdn-icons-png.flaticon.com/512/3063/3063826.png"
          alt="Attendance"
          style={styles.image}
        />
        <h2 style={styles.title}>Attendance Portal 🔑</h2>
        <p style={styles.subtitle}>Select your key to continue</p>

        <select
          value={dbKey}
          onChange={(e) => setDbKey(e.target.value)}
          style={styles.select}
        >
          <option value="">-- Select Key --</option>
          {options.map((key) => (
            <option key={key} value={key}>
              {key}
            </option>
          ))}
        </select>

        <button onClick={handleSubmit} style={styles.button}>
          Submit
        </button>
      </div>
    </div>
  );
};

// 🎨 Styles
const styles = {
  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
    fontFamily: "Arial, sans-serif",
  },
  card: {
    backgroundColor: "#fff",
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    textAlign: "center",
    width: "400px",
    maxWidth: "90%",
    animation: "fadeIn 1s ease-in-out",
  },
  image: {
    width: "100px",
    marginBottom: "20px",
  },
  title: {
    margin: "10px 0",
    fontSize: "24px",
    fontWeight: "bold",
    color: "#333",
  },
  subtitle: {
    marginBottom: "20px",
    fontSize: "14px",
    color: "#666",
  },
  select: {
    padding: "12px",
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #ccc",
    fontSize: "16px",
    marginBottom: "20px",
    outline: "none",
    cursor: "pointer",
  },
  button: {
    backgroundColor: "#4facfe",
    color: "#fff",
    padding: "12px 20px",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    cursor: "pointer",
    transition: "0.3s",
  },
};

export default DatabaseKeyPage;
